import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const ContactDiv = styled(BaseStyles.Div)`
    padding: 1.2rem 2rem;
`

export const ContactContentsDiv = styled(BaseStyles.Div)`
    margin: 0rem auto;
    min-width: 20rem;
    max-width: 140rem;
`

export const ContactFormDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 2px rgba(0, 0, 0, 0.022),
    0 0px 3px rgba(0, 0, 0, 0.031),
    0 0px 4px rgba(0, 0, 0, 0.039),
    0 0px 5px rgba(0, 0, 0, 0.048),
    0 0px 6px rgba(0, 0, 0, 0.07)
    ;   
    background-color: #383838;
    border-radius: 1.5rem;
    padding: 1.2rem;
`

export const ContactSectionHeader = styled(BaseStyles.SectionHeader)`
    color: white;
`

export const ContactInputField = styled(BaseStyles.InputField)`
    font-size: 1.6rem;
    height: 3rem;
`

export const FirstNameInputField = styled(ContactInputField)`
    width: 49.75%;
    margin: 0% 0.25% 0.25% 0%;
`

export const LastNameInputField = styled(ContactInputField)`
    width: 49.75%;
    margin: 0% 0% 0.25% 0.25%;
    float: right;
`

export const EmailInputField = styled(ContactInputField)`
    width: 100%;
    margin: 0.25% 0%;
`

export const SubjectDiv = styled(BaseStyles.Div)`
    width: 100%;
    margin: 0.25% 0%;
`

export const BodyTextArea = styled.textarea`
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    font-size: 1.6rem;
    width: 100%;
    height: 20rem;
    margin: 0.25% 0%;
    resize: none;
    box-sizing: border-box;
`

export const SendButtonDiv = styled(BaseStyles.Div)`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const SendButton = styled.button`
    margin: 0;
    padding: 1.1rem 0.8rem;
    font-size: 1.6rem;
    margin-top: 0.25rem;
    color: white;
    background-color: #4267B2;
    border-radius: 0.7rem;
    border: none;
`
